import React from 'react';
import { FULL_ACCESS_MAILTO, useIsTrial } from '../auth/features';

/** One-line app-shell notice for `trial` accounts. Renders nothing otherwise. */
export const TrialBanner: React.FC = () => {
    const isTrial = useIsTrial();
    if (!isTrial) return null;
    return (
        <div
            role="status"
            data-testid="trial-banner"
            className="shrink-0 border-b border-border bg-brand-cream/40 dark:bg-primary/10 px-4 py-1.5 text-xs text-foreground flex flex-wrap items-center justify-center gap-x-2"
        >
            <span>Trial account: triage, tracing, your cases and reports.</span>
            <a href={FULL_ACCESS_MAILTO} className="font-medium underline underline-offset-2">
                Request full access
            </a>
        </div>
    );
};
